import { Link, useParams } from "react-router-dom";

export function LangLink({ to, ...props }) {
  const { lang } = useParams();

  const prefixedTo =
    typeof to === "string"
      ? `/${lang}${to.startsWith("/") ? to : "/" + to}`
      : to;

  return <Link to={prefixedTo} {...props} />;
}
